import type { Client } from '@api/functions';
import type { DeactivateAccount, DeleteAccount } from '@api/types';

import { ApiTypes, client as defaultClient } from '../client';

export async function changePassword({ currentPassword, newPassword }: ApiTypes.ChangePassword) {
    return defaultClient.PATCH('/profile/password', {
        body: { currentPassword, newPassword },
    });
}

export async function getProfilePaymentDetails() {
    return defaultClient.GET('/profile/payment-details', {});
}

export async function updatePreferredLang(client?: Client) {
    return (client ?? defaultClient).PATCH('/profile/preferredLang', { body: {} });
}

export async function updateProfilePaymentDetails(data: ApiTypes.PaymentDetails) {
    return defaultClient.PATCH('/profile/payment-details', { body: data });
}

export async function updateProfile({
    location,
    spokenLanguages,
    translationLanguage,
    email,
    displayName,
}: ApiTypes.Profile) {
    return defaultClient.PATCH('/profile', {
        body: {
            location,
            spokenLanguages,
            translationLanguage,
            email,
            displayName,
        },
    });
}

export async function verifyEmail(client: Client, id: string, code: string) {
    return client.GET('/profile/confirm-email/{id}', {
        params: { query: { code }, path: { id } },
    });
}

export const deactivateAccount = (data: DeactivateAccount) => {
    return defaultClient.PATCH('/profile/deactivate', {
        body: data,
    });
};

export const deleteAccount = (data: DeleteAccount) => {
    return defaultClient.DELETE('/app/profile', {
        body: data,
    });
};

export const acceptUserAgreement = async () => {
    return defaultClient.GET('/profile/userAgreement', {});
};

export const updateSelfInfo = ({ spokenLanguages, displayName }: ApiTypes.SignupSelfInfo) => {
    return defaultClient.POST('/profile/spokenLanguages', { body: { spokenLanguages, displayName } });
};
